import * as React from "react";
import { forwardRef } from "react";
const SvgKeyboardArrowDownsvg = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", fill: "#e3e3e3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" }));
const ForwardRef = forwardRef(SvgKeyboardArrowDownsvg);
export { ForwardRef as ReactComponent };
